import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import * as moment from 'moment';
import {BehaviorSubject, Observable} from 'rxjs';
import Order from 'src/app/models/Order';
import {OrderType} from 'src/app/models/OrderType';
import {PaymentMethod} from 'src/app/models/PaymentMethod';
import {PreorderType} from 'src/app/models/PreorderType';
import {Venue} from 'src/app/models/Venue';
import {CountdownService} from 'src/app/services/countdown.service';
import {ManagerFacade} from 'src/app/store/manager/+state/manager.facade';

@Component({
	selector: 'app-order-countdown',
	templateUrl: './order-countdown.component.html',
	styleUrl: './order-countdown.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderCountdownComponent {
	@Input() order: Order;
	@Input() orderAt: string;

	venue$$ = new BehaviorSubject<Venue | null>(null);

	countdown$: Observable<number>;

	constructor(
		private countdownService: CountdownService,
		private managerFacade: ManagerFacade
	) {
		this.managerFacade.venue$.subscribe(venue => {
			this.venue$$.next(venue);
		});
	}

	ngOnInit(): void {
		const countdownTarget = this.getCountdownStart();
		const targetTime = countdownTarget;
		this.countdown$ = this.countdownService.getCountdown(targetTime);
	}

	getCountdownStart(): moment.Moment {
		// const orderMoment = moment(this.order.orderAt);
		// if (this.order.code === '528') {
		// 	console.log('-------------- order -----------', this.order);

		// 	console.log(orderMoment.format('HH:mm:ss'));

		// }

		// if (this.order.asap) {
		// 	return orderMoment.add(this.getOffset(), 'minutes');
		// }

		const slotMoment = moment(this.orderAt);

		return slotMoment;
	}

	formatTime(seconds: number): string {
		const abs = Math.abs(seconds);
		const m = Math.floor(abs / 60) + 1;
		// const s = abs % 60;
		return `${seconds < 0 ? '-' : ''}${m}m`;
	}

	getOffset() {
		if (
			(this.order.type === OrderType.PREORDER &&
				this.order.preorder.type === PreorderType.DELIVERY) ||
			this.order.method === PaymentMethod.UBER_EATS ||
			this.order.method === PaymentMethod.WOLT ||
			this.order.method === PaymentMethod.JET
		) {
			return this.venue$$.getValue()?.slot.readyOffsetDelivery || -1;
		} else if (this.order.type === OrderType.PREORDER) {
			return this.venue$$.getValue()?.slot.readyOffset || -1;
		}
		return -1;
	}

	isShowTimer(seconds: number): boolean {
		return this.getOffset() * 60 > seconds && this.getOffset() >= 0;
	}
}
